import React from 'react';
import { Text } from '../../../../../../ui/atoms/Text/Text';
import { Button } from '../../../../../../ui/atoms/Button/Button';
import { SUPPORT_COPY, SUPPORT_DELIVERY } from '../../../../constants/support';
import './SupportDeliveryStatusStyles.scss';
const BASE_CLASS = 'ai-support-delivery-status';
/**
 * Delivery state under a customer message sent to a human: Sending… / Sent / Not sent. Retry.
 * "Sent" is shown only once the server has accepted the message — never merely because a
 * local bubble exists.
 */
export function SupportDeliveryStatus({ delivery, onRetry }) {
    if (delivery === SUPPORT_DELIVERY.FAILED) {
        return (React.createElement("div", { className: `${BASE_CLASS} ${BASE_CLASS}--failed`, role: "status" },
            React.createElement("i", { className: "fa-light fa-triangle-exclamation", "aria-hidden": "true" }),
            React.createElement(Text, { variant: "xx-small" }, SUPPORT_COPY.DELIVERY_FAILED),
            onRetry && React.createElement(Button, { onClick: onRetry }, SUPPORT_COPY.DELIVERY_RETRY)));
    }
    return (React.createElement("div", { className: BASE_CLASS, role: "status" },
        React.createElement(Text, { variant: "xx-small" }, delivery === SUPPORT_DELIVERY.SENDING ? SUPPORT_COPY.DELIVERY_SENDING : SUPPORT_COPY.DELIVERY_SENT)));
}
